export default __webpack_public_path__ + "static/media/retaining-good-people.126bafb5.svg";